import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice de charge électrique - Calcul de la charge électrique";
const DESCRIPTION =
  "Calculatrice de charge électrique - Calcul de la charge électrique. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "electric charge, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/electric-charge";
function ElectricChargeCalculator() {
  const [force, setForce] = useState("");
  const [distance, setDistance] = useState("");
  const [chargeMagnitude, setChargeMagnitude] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!force || !distance) {
      setError("Veuillez entrer la force et la distance correctement");
      setChargeMagnitude("");
      return;
    }
    const electrostaticConstant = 8.99e9;
    const forceValue = parseFloat(force);
    const distanceValue = parseFloat(distance);
    if (isNaN(forceValue) || isNaN(distanceValue)) {
      setError("Veuillez entrer des valeurs numériques correctes");
      setChargeMagnitude("");
      return;
    }
    const chargeMagnitudeValue = Math.sqrt(
      (forceValue * distanceValue ** 2) / electrostaticConstant
    );
    setChargeMagnitude(
      `Force d'interaction entre les charges : ${forceValue} Newton <br/>
            Distance entre les charges : ${distanceValue} mètre <br/>
            Charge électrique sur chaque sphère : ${chargeMagnitudeValue.toFixed(
              2
            )} Coulomb <br/>
            (Note : la charge a été calculée sur la base de la loi de Coulomb pour les interactions électriques)`
    );
    setError("");
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>
                  Comment calculer la charge électrique
                </h2>
                <p>
                  Vous pouvez utiliser cette calculatrice pour calculer la quantité de charge électrique sur deux sphères chargées en utilisant la loi de Coulomb pour les interactions électriques.
                </p>
                <p>
                  Force = (Constante électrostatique × |Première charge × Deuxième charge|) / (Distance^2)
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Force (Newton)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="Entrer la force"
                        value={force}
                        onChange={(e) => setForce(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Distance (m)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="Entrer la distance"
                        value={distance}
                        onChange={(e) => setDistance(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur : {error}
                      </p>
                    ) : (
                      chargeMagnitude !== "" && (
                        <div
                          className="p-3 mb-2 bg-success text-white"
                          dangerouslySetInnerHTML={{ __html: chargeMagnitude }}
                        />
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default ElectricChargeCalculator;
